import React, { Component } from 'react';
import { connect } from 'react-redux';
import { logout } from '~/apps/shared/actions/auth';
import { navigate } from '~/router';

type Props = {
  dispatch: any,
}

class Logout extends Component<Props> {

  componentDidMount(): void {
    const { dispatch } = this.props;

    dispatch(logout())
      .then(() => {
        navigate('login');
      });
  }

  render() {
    return null;
  }
}

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(null, mapDispatchToProps)(Logout);
